const languageActionTypes={
    LANGUAGE_UPDATE:'langauge_update',
    LANGUAGE_SUCCESS: 'language_success',

    LANGUAGE_LIST_REQUEST: 'language_list_request',
    LANGUAGE_LIST_SUCCESS: 'language_list_success',
}
export default languageActionTypes;